/* global jQuery */
import ScreenLock from '../../constants/lock-screen';
class Gallery {
    constructor(element) {
        Object.defineProperty(this, "openTrigger", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "closeTrigger", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lightbox", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "slider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "prevArrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nextArrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "refSlider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lightboxOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.openTrigger = element.querySelectorAll('.image-gallery-single');
        this.closeTrigger = element.querySelector('.close-gallery-lightbox');
        this.lightbox = element.querySelector('.image-gallery-lightbox');
        this.slider = element.querySelector('.slick-slider');
        this.prevArrow = element.querySelector('.slick-slider-arrow-prev') ?? undefined;
        this.nextArrow = element.querySelector('.slick-slider-arrow-next') ?? undefined;
        this.refSlider = undefined;
        this.lightboxOpen = false;
        for (const element of this.openTrigger) {
            element.addEventListener('click', this.openLightBox.bind(this));
        }
        this.closeTrigger?.addEventListener('click', this.closeLightBox.bind(this));
        window.addEventListener('resize', () => {
            if (this.lightboxOpen && this.lightbox) {
                this.lightbox.style.height = `${window.innerHeight}px`;
            }
        });
    }
    initSlider() {
        if (this.slider) {
            this.refSlider = jQuery(this.slider).slick({
                variableWidth: true,
                centerMode: true,
                rows: 0,
                lazyLoad: 'progressive',
                prevArrow: this.prevArrow,
                nextArrow: this.nextArrow,
            });
        }
    }
    openLightBox(event) {
        if (!this.lightbox) {
            return;
        }
        if (!this.refSlider) {
            this.initSlider();
        }
        this.lightbox.style.height = `${window.innerHeight}px`;
        ScreenLock.lock();
        const image = event.currentTarget;
        const imageId = image.dataset.image;
        const slickImage = this.slider?.querySelector(`.slick-slide:not(.slick-cloned)[data-slide="${imageId}"]`);
        const slickIndex = slickImage?.dataset.slickIndex;
        this.refSlider?.slick('slickGoTo', slickIndex, true);
        this.lightbox.classList.add('active');
        this.lightboxOpen = true;
    }
    closeLightBox() {
        if (this.lightboxOpen) {
            ScreenLock.unlock();
            this.lightbox?.classList.remove('active');
            this.lightboxOpen = false;
        }
    }
}
export default function gallery() {
    const gallery = document.querySelectorAll('.block-image-gallery');
    for (const element of gallery) {
        new Gallery(element);
    }
}
